<template>
  <div id="isInitial" v-if="isInitial">
      <Loading :loading="this.loading"></Loading>
      <article v-show="!loading">
        <div class="step-bar-container">
          <ul>
            <li class="li-step active">
              <span class="stepnum num01"></span>
              <span class="steptext">条件入力</span>
            </li>
            <li class="li-step">
              <span class="stepnum num02"></span>
              <span class="steptext">見積り確認</span>
            </li>
            <li class="li-step">
              <span class="stepnum num03"></span>
              <span class="steptext">連絡先入力</span>
            </li>
            <li class="li-step">
              <span class="stepnum num04"></span>
              <span class="steptext">最終確認</span>
            </li>
          </ul>
        </div>
        <header class="header white-panel mb2p">
          <h3 class="section-title mb8" id="inspectSs">コミっと車検実施店舗</h3>
          <template v-if="inspectSsInfo.komikomi_flag === 1">
            <h2 class="section-title">{{inspectSsInfo.ss_name}}</h2>
          </template>
          <template v-else>
            <dt class="pb8 fs14">車検証情報は店舗選択後に入力ください。</dt>
            <button v-on:click="openSelectSS()" class="button fs16 mb8">実施店舗を選択する</button>
            <div class="content-box color-red2">
              ※{{inspectSsInfo.ss_name}}は「コミっと車検」非対応店舗です。<br>
              コミっと車検を実施する際の店舗を選択してください。
            </div>
          </template>
        </header>
        <section class="section white-panel mb2p">
          <h3 class="section-title mb8">車検証情報</h3>
          <button v-on:click="openQrCode()" v-bind:disabled="isNotKomikomi" class="button button-scan mb8">QRコードでかんたん入力</button>
          <div class="content-box color-green2">
            <img src="/lib/images/tips.svg" class="pr8">QRを読み込むと情報が一瞬で入力できます
          </div>
          <dl class="dl dl-l dl-fs16 dt65-dd35 dl-bottom-line dl-toggle pb24 mb24"></dl>
            <dt class="pb8 fs14" id="expiryGengo">車検満了日</dt>
            <dl class="dl">
            <dd>
              <div class="dropdown">
                <WarekiInputFromH @click="isChange = true" :isDisabled="isQrData || isNotKomikomi" v-model="car.expiryGengo" :isInvalid="!!form.expiryErrorMessage" ref="expiryOnFromH"></WarekiInputFromH>
                </div>
                <span class="date-y ml4 mr4">年</span>
                <div class="dropdown">
                <vue-select-v2 @click="isChange = true" :isDisabled="isQrData || isNotKomikomi" name="select" v-model="form.expiryMonthSelect" :options="month" :isInvalid="!!form.expiryErrorMessage">
                  <template v-slot:default="props">
                    <option v-for="(option, key) in props.options"
                            :key="key"
                            :value=option.id
                            :selected="form.expiryMonthSelect === option.id"
                    >{{ option.value }}</option>
                  </template>
                </vue-select-v2>
                </div>
              <span class="date-m ml4 mr4">月</span>
              <div class="dropdown">
                <vue-select-v2 @click="isChange = true" :isDisabled="isQrData || isNotKomikomi" name="select" v-model="form.expiryDaySelect" :options="day" :isInvalid="!!form.expiryErrorMessage">
                  <template v-slot:default="props">
                    <option v-for="(option, key) in props.options"
                            :key="key"
                            :value=option.id
                            :selected="form.expiryDaySelect === option.id"
                    >{{ option.value }}</option>
                  </template>
                </vue-select-v2>
              </div>
              <span class="date-d ml4">日</span>
            </dd>
            <dd class="error">
              <p class="error-text">{{form.expiryErrorMessage}}</p>
            </dd>
            </dl>

            <dt id="firstRegistrationGengo" class="pb8 fs14">初度登録年月</dt>
            <dl class="dl">
            <dd>
              <div class="dropdown">
                <WarekiInputFromH @click="isChange = true" :isDisabled="isQrData || isNotKomikomi" v-model="car.firstRegistrationGengo" :isInvalid="!!form.firstRegistrationErrorMessage" ref="firstRegistration"></WarekiInputFromH>
              </div>
              <span class="date-y ml4 mr4">年</span>

              <div class="dropdown">
                <vue-select-v2 @click="isChange = true" :isDisabled="isQrData || isNotKomikomi" name="select" v-model="form.firstRegistrationMonthSelect" :options="month" :isInvalid="!!form.firstRegistrationErrorMessage">
                  <template v-slot:default="props">
                    <option v-for="(option, key) in props.options"
                            :key="key"
                            :value="option.id"
                            :selected="form.firstRegistrationMonthSelect === option.id"
                    >{{ option.value }}</option>
                  </template>
                </vue-select-v2>
              </div>
              <span class="date-m ml4 mr4">月</span>
            </dd>
            <dd class="error">
              <p class="error-text">{{form.firstRegistrationErrorMessage}}</p>
            </dd>
            </dl>

            <dt id="modelCode" class="pb8 fs14">自動車種別</dt>
            <dd class="mb12">
              <div class="dropdown w100p fs14">
                <select @click="isChange = true" v-bind:disabled="isQrData || isNotKomikomi" name="" class="select w100p" v-bind:class="{ 'error': form.modelCodeErrorMessage }" v-model="car.model_code">
                  <option :value="null">選択してください</option>
                  <option
                    v-for="carType in carTypes"
                    :key="carType.id"
                    :value="carType.id">
                    {{ carType.name }}
                  </option>
                </select>
              </div>
            </dd>
            <dd class="dl error">
              <p class="error-text">{{form.modelCodeErrorMessage}}</p>
            </dd>

            <dt id="manufacturer" class="pb8 fs14">車名(メーカー)</dt>
            <dd class="mb12">
              <div class="dropdown w100p fs14">
                <select @click="isChange = true" v-bind:disabled="isQrData || isNotKomikomi" name="" class="select w100p" v-bind:class="{ 'error': form.manufacturerErrorMessage }" v-model="car.manufacturer_id">
                  <option :value="null">選択してください</option>
                  <option
                    v-for="manufacturer in manufacturers"
                    :key="manufacturer.id"
                    :value="manufacturer.id">
                    {{ manufacturer.manufacturer_name }}
                  </option>
                </select>
              </div>
            </dd>
            <dd class="dl error">
              <p class="error-text">{{form.manufacturerErrorMessage}}</p>
            </dd>
            <dt id="weight" class="pb8 fs14">車両重量</dt>
            <dd class="mb12 fs14" align="right">
              <input @click="isChange = true" v-bind:disabled="isQrData || isNotKomikomi" id="car_weight" v-on:blur="replaceNumber('weight')" v-model="car.weight" type="number" pattern="\d*" placeholder="(例)1,000" class="w6_0em pl-text-right text-right" v-bind:class="{ 'error': form.weightErrorMessage }"><span class="fs16 ml4">kg</span>
            </dd>
            <dd class="dl error" align="right">
              <p class="error-text">{{form.weightErrorMessage}}</p>
            </dd>
        </section>

        <section class="section white-panel mb2p">
          <h3 class="pb12 section-title">ダッシュボード情報</h3>
          <dt id="modelCode" class="pb8 fs14">走行距離</dt>
            <dd class="mb12">
              <div class="dropdown w100p fs14">
                <select class="select w100p" v-bind:disabled="isNotKomikomi" v-bind:class="{ 'error': form.mileagErrorMessage }" name="select" v-model="car.mileage">
                  <option :value="null">選択してください</option>
                    <option
                    v-for="mileage in mileages"
                    :key="mileage.id"
                    :value="mileage.id">
                    {{ mileage.value }}
                  </option>
                </select>
              </div>
            </dd>
            <dl class="dl estimate-list">
              <dd class="error">
                <p class="error-text">{{form.mileagErrorMessage}}</p>
              </dd>
            </dl>

          <p class="color-font2">※20万km以上はコミっと車検の対象外となります</p>
        </section>

        <section class="section white-panel mb2p">
          <h3 class="section-title">エンジンオイル交換</h3>
          <dl class="dl dt50-dd50">
            <dt class="fs16 pt8">エンジンオイル交換</dt>
            <dd>
              <fieldset class="radio-check">
                <input id="item-1" class="radio-inline_input" type="radio" name="radio" v-bind:value=true v-model="car.oil_exchanged" v-bind:disabled="isNotKomikomi"/>
                <label class="radio-inline_label mr4" for="item-1">必要</label>
                <input id="item-2" class="radio-inline_input" type="radio" name="radio" v-bind:value=false v-model="car.oil_exchanged" v-bind:disabled="isNotKomikomi"/>
                <label class="radio-inline_label" for="item-2">不要</label>
              </fieldset>
            </dd>
          </dl>
          <div class="content-box color-green2">
            <img src="/lib/images/tips.svg" class="pr8">オイル交換のタイミングの目安は半年です
          </div>
        </section>
        <section class="section white-panel mb2p" v-if="coupon.name">
          <h3 class="section-title">クーポン</h3>
          <dl class="dl estimate-list">
            <dt class="fs16 pt8">{{coupon.name}}</dt>
            <dd class="pt8">
              <p>{{coupon.shortDescription}}</p>
            </dd>
          </dl>
        </section>

        <div class="section">
          <p class="text-center color-font2">※見積り金額以外にも料金が変動する場合があります</p>
          <button v-bind:disabled="processing || isNotKomikomi" v-on:click='validationCheck(car, form)' class="button button-estimate">見積りを始める</button>
          <p class="text-center mb0 fs13">特定商取引にかかわる表記については<a href="#" v-on:click="toAgreement()">こちら</a></p>
        </div>

      </article>

      <!-- カーケアTOPに戻るボタン -->
      <form name="fm">
        <input id="tsid" type="hidden" name="tsid" v-bind:value="this.nativeDataStore.nativeData.tsid">
        <input id="popinfoid" type="hidden" name="popinfoid" v-bind:value="this.nativeDataStore.nativeData.popinfoid">
        <input id="otoken" type="hidden" name="otoken" v-bind:value="this.nativeDataStore.nativeData.otoken">
        <input id="x_cls_app_version" type="hidden" name="appversion" v-bind:value="this.versionDataStore.versionData.appVersion">
        <input id="x_cls_os" type="hidden" name="platform" v-bind:value="this.versionDataStore.versionData.platform">
        <input id="x_cls_os_version" type="hidden" name="osversion" v-bind:value="this.versionDataStore.versionData.osVersion">
      </form>
      <a id="qrdone" v-on:click="qrdone()"></a>
      <a id="selectedSsDone" v-on:click="selectedSsDone()"></a>
  </div>
  <div v-else-if="isAgreement">
    <a id="isAgreement" v-on:click="toInitial()"></a>
    <Agreement></Agreement>
  </div>
</template>

<style scoped>
.button-scan:disabled, .button-scan[disabled] {
  background-color: #EDF0F0;
  opacity: 0.5;
}
</style>

<script>

import { mapActions, mapGetters } from 'vuex'
import carApi from '@/store/Api/car'
import carTypeApi from '@/store/Api/cartype'
import otherCouponApi from '@/store/Api/Common/otherCoupon'
import manufacturerApi from '@/store/Api/manufacturers'
import ssApi from '@/store/Api/Common/ss'
import ssByScdApi from '@/store/Api/Common/ssByScd'
import cmsCarCopyApi from '@/store/Api/Common/cmsCarCopy'
import WarekiInput from '@/components/v2/WarekiInput.vue'
import WarekiInputFromH from '@/components/v2/WarekiInputFromH.vue'
import moment from 'moment'
import modal from '@/assets/v2/modal'
import Loading from '@/views/v2/Loading.vue'
import Agreement from '@/views/v2/Agreement.vue'
import userInfo from '@/store/Api/Common/userInfo'
import updateCar from '@/store/Api/MaintenancePack/updateCar'
import appVerApi from '@/store/Api/Common/appVer'
import { useSsInfoStore } from '@/store/ssInfo'
import { useProfileInfoStore } from '@/store/profileInfo'
import { useNativeDataStore } from '@/store/nativeData'
import { useVersionDataStore } from '@/store/versionData'
import { useCarStore } from '@/store/carData'
import { useInspectSsInfoStore } from '@/store/inspectSsInfo'
import { useTsIdStore } from '@/store/tsId'

const IS_INITIAL = 'IS_INITIAL'
const IS_AGREEMENT = 'IS_AGREEMENT'

export default {
  data: () => ({
    loading: true,
    isQrData: false,
    isChange: false,
    processing: false,
    currentState: IS_INITIAL,
    form: {
      expiryMonthSelect: '00',
      expiryDaySelect: '00',
      firstRegistrationMonthSelect: '00',
      expiryErrorMessage: '',
      modelCodeErrorMessage: '',
      firstRegistrationErrorMessage: '',
      manufacturerErrorMessage: '',
      weightErrorMessage: '',
      mileagErrorMessage: ''

    },
    month: [
      { id: '00', value: '' },
      { id: '01', value: 1 },
      { id: '02', value: 2 },
      { id: '03', value: 3 },
      { id: '04', value: 4 },
      { id: '05', value: 5 },
      { id: '06', value: 6 },
      { id: '07', value: 7 },
      { id: '08', value: 8 },
      { id: '09', value: 9 },
      { id: '10', value: 10 },
      { id: '11', value: 11 },
      { id: '12', value: 12 }
    ],
    day: [
      { id: '00', value: '' },
      { id: '01', value: 1 },
      { id: '02', value: 2 },
      { id: '03', value: 3 },
      { id: '04', value: 4 },
      { id: '05', value: 5 },
      { id: '06', value: 6 },
      { id: '07', value: 7 },
      { id: '08', value: 8 },
      { id: '09', value: 9 },
      { id: '10', value: 10 },
      { id: '11', value: 11 },
      { id: '12', value: 12 },
      { id: '13', value: 13 },
      { id: '14', value: 14 },
      { id: '15', value: 15 },
      { id: '16', value: 16 },
      { id: '17', value: 17 },
      { id: '18', value: 18 },
      { id: '19', value: 19 },
      { id: '20', value: 20 },
      { id: '21', value: 21 },
      { id: '22', value: 22 },
      { id: '23', value: 23 },
      { id: '24', value: 24 },
      { id: '25', value: 25 },
      { id: '26', value: 26 },
      { id: '27', value: 27 },
      { id: '28', value: 28 },
      { id: '29', value: 29 },
      { id: '30', value: 30 },
      { id: '31', value: 31 }
    ],
    mileages: [
      { id: 10, value: '20,000km未満' },
      { id: 30, value: '20,000 ~ 39,999km' },
      { id: 50, value: '40,000 ~ 59,999km' },
      { id: 70, value: '60,000 ~ 79,999km' },
      { id: 90, value: '80,000 ~ 99,999km' },
      { id: 150, value: '100,000 ~ 199,999km' },
      { id: 210, value: '200,000km以上' }
    ],
    carTypes: [],
    manufacturers: [],
    profileInfo: [],
    coupon: {
      name: '',
      salevalue: null,
      shortDescription: '利用クーポン無し',
      usableStartAt: '',
      usableEndAt: '',
      description: ''
    },
    ssInfo: {},
    inspectSsInfo: {}
  }),

  methods: {
    ...mapActions('CAR', [
      'setCar'
    ]),
    toInitial () {
      this.currentState = IS_INITIAL
      window.scrollTo(0, 0)
    },
    toAgreement () {
      this.currentState = IS_AGREEMENT
      this.nativeEVENTSet('ShakenButton', 'MOVED_SHAKEN_KOKANKIJYUN', 'TAP')
      window.scrollTo(0, 0)
    },
    setCoupon (coupon) {
      this.coupon = coupon
    },
    setUserInfo (userInfo) {
      this.userInfo = userInfo
    },
    isDate (strDate) {
      // 空文字は無視
      if (strDate === '') {
        return false
      }
      // 年/月/日の形式のみ許容する
      if (!strDate.match(/^\d{4}\-\d{1,2}\-\d{1,2}$/)) {
        return false
      }

      // 日付変換された日付が入力値と同じ事を確認
      // new Date()の引数に不正な日付が入力された場合、相当する日付に変換されてしまうため
      //
      const date = new Date(strDate)
      if (date.getFullYear().toString() !== strDate.split('-')[0] ||
          date.getMonth() !== strDate.split('-')[1] - 1 ||
          date.getDate() !== Number(strDate.split('-')[2])
      ) {
        return false
      }

      return true
    },
    openErrorModal (message) {
      modal.alert(message)
    },
    replaceNumber (name) {
      if (name === 'weight') {
        this.car.weight = Number(this.car.weight)
      } else if (name === 'mileage') {
        this.car.mileage = Number(this.car.mileage)
      }
    },
    async validationCheck (car, form) {
      let isSuccses = true
      this.processing = true
      this.car.expiry_on = this.car.expiryGengo + '-' + this.form.expiryMonthSelect + '-' + this.form.expiryDaySelect
      this.car.first_registration_on = this.car.firstRegistrationGengo + '-' + this.form.firstRegistrationMonthSelect

      const nowMonth = moment().format('YYYY-MM')
      const nowDay = moment().format('YYYY-MM-DD')
      const expiryDay = moment(car.expiry_on).format('YYYY-MM-DD')
      const firstMonth = moment(car.first_registration_on).format('YYYY-MM')

      // イベントトラッキング処理
      this.nativeEVENTSet('ShakenButton', 'MOVED_MITSUMORI_KEKKA', 'TAP')

      // 車検実施SS
      if (this.inspectSsInfo.komikomi_flag !== 1) {
        isSuccses = false
      }

      // 車検満了日
      if (!this.isDate(car.expiry_on)) {
        form.expiryErrorMessage = '恐れ入りますが、正しい車検満了日を登録してください。'
        isSuccses = false
      } else if (moment(nowDay).isAfter(expiryDay, 'day')) {
        form.expiryErrorMessage = '恐れ入りますが、車検切れのお車は本車検サービスの対象外となっております。'
        isSuccses = false
      } else {
        form.expiryErrorMessage = ''
      }

      // 初度登録年月
      const firstRegistrationOn = this.dateParseYearMonth(this.car.first_registration_on)
      // 現在年月の20年前を取得(初度登録年月は常に日は1日のため、1日を設定)
      const twentyYearsAgo = moment().startOf('month').subtract({
        years: 20
      }).toDate()

      if (!this.isDate(car.first_registration_on + '-01')) {
        form.firstRegistrationErrorMessage = '恐れ入りますが、正しい初度登録年月を登録してください。'
        isSuccses = false
      } else if (moment(nowMonth).isBefore(firstMonth)) {
        form.firstRegistrationErrorMessage = '恐れ入りますが、正しい初度登録年月を登録してください。'
        isSuccses = false
      } else if (firstRegistrationOn <= twentyYearsAgo) {
        form.firstRegistrationErrorMessage = '恐れ入りますが、お客様のお車は本車検サービスの対象外となっております。'
        isSuccses = false
      } else {
        form.firstRegistrationErrorMessage = ''
      }

      // 自動車種別
      if (!car.model_code) {
        form.modelCodeErrorMessage = '自動車種別を選択して下さい。'
        isSuccses = false
      } else if (car.model_code === 4) {
        form.modelCodeErrorMessage = '恐れ入りますが、お客様のお車は本車検サービスの対象外となっております。'
        isSuccses = false
      } else {
        form.modelCodeErrorMessage = ''
      }

      // 車名(メーカー)
      if (!car.manufacturer_id) {
        form.manufacturerErrorMessage = '車名(メーカー)を選択して下さい。'
        isSuccses = false
      } else if (car.manufacturer_id === 9 || car.manufacturer_id === 10) {
        form.manufacturerErrorMessage = '恐れ入りますが、お客様のお車は本車検サービスの対象外となっております。'
        isSuccses = false
      } else {
        form.manufacturerErrorMessage = ''
      }

      // 車両重量
      if (!this.isInteger(car.weight)) {
        form.weightErrorMessage = '車両重量は半角整数で入力して下さい。'
        isSuccses = false
      } else if (car.weight === '') {
        form.weightErrorMessage = '車両重量は必須入力です。'
        isSuccses = false
      } else if (Number(car.weight) === 0) {
        form.weightErrorMessage = '車両重量は0以上を入力して下さい。'
        isSuccses = false
      } else if (String(car.weight).length > 8) {
        form.weightErrorMessage = '車両重量は8桁以内を入力して下さい。'
        isSuccses = false
      } else {
        form.weightErrorMessage = ''
      }

      // 走行距離
      if (!car.mileage) {
        form.mileagErrorMessage = '走行距離を選択して下さい。'
        isSuccses = false
      } else if (Number(car.mileage) >= 210) {
        form.mileagErrorMessage = '恐れ入りますが、お客様のお車は本車検サービスの対象外となっております。'
        isSuccses = false
      } else {
        form.mileagErrorMessage = ''
      }

      if (isSuccses) {
        // 車検証作成APIをコール
        await this.carApiPost(car)
        // ユーザー情報取得APIをコール
        await this.userInfoApiGet()
        // ログインユーザーかつ車検証QR読み取りであれば車検証更新APIをコール
        if (this.userInfo.authid && car.qr) {
          await this.updateCarApiPut(car)
        }
        // CMS車検証コピーAPIをコール
        await this.cmsCarCopyApiPost(car)
        // 見積もり結果画面に遷移する
        this.moveToEstimate(car)
      } else {
        let scrollId = ''
        if (this.inspectSsInfo.komikomi_flag !== 1) {
          scrollId = '#inspectSs'
        } else if (form.expiryErrorMessage !== '') {
          scrollId = '#expiryGengo'
        } else if (form.firstRegistrationErrorMessage !== '') {
          scrollId = '#firstRegistrationGengo'
        } else if (form.modelCodeErrorMessage !== '') {
          scrollId = '#modelCode'
        } else if (form.manufacturerErrorMessage !== '') {
          scrollId = '#manufacturer'
        } else if (form.weight !== '') {
          scrollId = '#weight'
        } else if (form.mileage !== '') {
          scrollId = '#mileage'
        }
        this.$SmoothScroll(
          document.querySelector(scrollId),
          500,
          null,
          null,
          'y'
        )
      }
      this.processing = false
    },
    // CMS車検証コピーAPI用にリクエストボディを作成します.
    makeCmsCarCopyParam (car) {
      const requestParam = {}
      requestParam.id = car.id
      requestParam.popinfo_id = car.popinfo_id
      requestParam.ss_code = this.inspectSsInfo.ss_code
      requestParam.chassis_number = car.chassis_number
      requestParam.model_code = car.model_code
      requestParam.manufacturer_id = car.manufacturer_id
      requestParam.qr_row = car.qr
      requestParam.weight = car.weight
      requestParam.first_registration_on = car.first_registration_on
      requestParam.expiry_on = car.expiry_on
      requestParam.motor_model = car.motor_model
      requestParam.type_designation_number = car.type_designation_number
      requestParam.classification_division_number = car.classification_division_number

      // QR読み取りの場合のみ、ナンバープレート、軸重、型式をQR文字列から整形する.
      if (car.qr) {
        const res = this.qrFormat(car.qr, car.model_code)
        requestParam.plate_number1 = res.plate_number1
        requestParam.plate_number2 = res.plate_number2
        requestParam.plate_number3 = res.plate_number3
        requestParam.plate_number4 = res.plate_number4
        requestParam.axle_load_front_front_weight = res.axle_load_front_front_weight
        requestParam.axle_load_front_back_weight = res.axle_load_front_back_weight
        requestParam.axle_load_back_front_weight = res.axle_load_back_front_weight
        requestParam.axle_load_back_back_weight = res.axle_load_back_back_weight
        requestParam.model = res.model
      }
      console.log('*** cmsCarCopyApiPost-requestParam ***')
      console.log(requestParam)

      return requestParam
    },
    /**
    * 見積もり結果画面遷移関数
    */
    moveToEstimate (car) {
      const carStore = useCarStore()
      carStore.car = car
      const nativeDataStore = useNativeDataStore()
      nativeDataStore.nativeData = this.nativeDataStore.nativeData
      const tsIdStore = useTsIdStore()
      tsIdStore.tsId = this.tsIdStore.tsId
      const ssInfoStore = useSsInfoStore()
      ssInfoStore.ssInfo = this.ssInfoStore.ssInfo
      const inspectSsInfoStore = useInspectSsInfoStore()
      inspectSsInfoStore.inspectSsInfo = this.inspectSsInfo
      const profileInfoStore = useProfileInfoStore()
      profileInfoStore.profileInfo = this.profileInfoStore.profileInfo
      const versionDataStore = useVersionDataStore()
      versionDataStore.versionData = this.versionDataStore.versionData

      this.$router.push({ name: 'EstimateV2' })
    },
    /**
    * 車検証作成API呼び出し関数
    * @param {object} car - 車検証オブジェクト
    */
    async carApiPost (car) {
      if (this.isChange) {
        // 走行距離以外が選択(click)された場合、QR読み取り以外と判断し、初期化.
        car.chassis_number = ''
        car.plate_number = ''
        car.motor_model = ''
        car.type_designation_number = ''
        car.classification_division_number = ''
        car.qr = ''
      }

      await carApi.post(car).then(res => {
        car.id = res.data
      }).catch(e => {
        console.log('carApiPost-error')
        this.openErrorModal('エラーが発生しました。')
      })
    },
    /**
    * CMS車検証コピーAPI呼び出し関数
    * @param {object} car - 車検証オブジェクト
    */
    async cmsCarCopyApiPost (car) {
      await cmsCarCopyApi.post(this.nativeDataStore.nativeData, this.makeCmsCarCopyParam(car), this.appVersionMakeRequestHeder(this.versionDataStore.versionData)).then(res => {
        console.log('*** cmsCarCopyApi-success ***')
      }).catch(e => {
        console.log('cmsCarCopyApi-error')
        console.log(e.message)
        // ユーザの操作を妨げることになるためCMSコピーに失敗した場合でもErrorModalは表示しない.
      })
    },
    /**
    * ユーザー情報取得API呼び出し関数
    */
    async userInfoApiGet () {
      // ユーザー情報取得
      console.log('call-userInfoApiGet')
      await userInfo.get(this.nativeDataStore.nativeData, this.appVersionMakeRequestHeder(this.versionDataStore.versionData)).then(res => {
        this.setUserInfo(res.data.body.id)
        console.log('*** userInfoApiGet-success ***')
      }).catch(e => {
        console.log('userInfo-error')
        console.log(e)
        this.openErrorModal('エラーが発生しました。')
      })
    },
    /**
    * 車検証情報更新API呼び出し関数
    * @param {object} car - 車検証オブジェクト
    */
    async updateCarApiPut (car) {
      // 車検証情報更新API
      console.log('call-updateCarApiPut')
      const updateCarApiParam = {
        authid: this.userInfo.authid,
        ss_code: this.inspectSsInfo.ss_code,
        car_id: car.id,
        expiry_on: car.expiry_on,
        chassis_number: car.chassis_number
      }
      console.log(updateCarApiParam)
      await updateCar.put(updateCarApiParam).then(res => {
        console.log('*** updateCar-success ***')
      }).catch(e => {
        console.log('updateCar-error')
        console.log(e)
        this.openErrorModal('エラーが発生しました。')
      })
    },
    setCarType (carTypes) {
      this.carTypes = carTypes
    },
    setManufacturer (manufacturers) {
      this.manufacturers = manufacturers
    },
    setSsInfo (ssInfo) {
      this.ssInfo = ssInfo
    },
    openQrCode () {
      if (this.isNotKomikomi) {
        // コミっと車検 非対応店の場合
        return
      }
      this.nativeEVENTSet('ShakenButton', 'MOVED_QRCAMERA', 'TAP')
      if ('Android' in window) {
        Android.setQRData('qrdata')
      } else if ('webkit' in window) {
        webkit.messageHandlers.setQRData.postMessage('qrdata')
      }
    },
    qrdone () {
      const qr = window.QR_DATA.body

      this.car.plate_number = qr.plate_number
      this.car.chassis_number = qr.chassis_number
      this.car.motor_model = qr.motor_model
      this.car.type_designation_number = qr.type_designation_number
      this.car.classification_division_number = qr.classification_division_number
      this.car.model_code = qr.model_code
      this.car.model_name = qr.model_name
      this.car.manufacturer_id = qr.manufacturer_id
      this.car.manufacturer_name = qr.manufacturer_name
      this.car.weight = qr.weight
      this.car.qr = qr.qr_data

      // 車検満了日
      this.car.expiry_on = qr.expiry_on
      this.car.expiryGengo = Number(qr.expiry_on.substr(0, 4))
      this.form.expiryMonthSelect = qr.expiry_on.substr(5, 2)
      this.form.expiryDaySelect = qr.expiry_on.substr(8, 2)

      // 初度登録年月
      this.car.first_registration_on = qr.first_registration_on
      this.car.firstRegistrationGengo = Number(qr.first_registration_on.substr(0, 4))
      this.form.firstRegistrationMonthSelect = qr.first_registration_on.substr(5, 2)

      this.setCar(this.car)
      // 車検満了日、初度登録年月の元号、年を取得してセットする。
      this.$refs.expiryOnFromH.firstGetGengo(qr.expiry_on)
      this.$refs.firstRegistration.firstGetGengo(qr.first_registration_on)

      this.isQrData = true
      this.isChange = false
    },
    openSelectSS () {
      if ('Android' in window) {
        Android.addMySs('selectedSs')
      } else if ('webkit' in window) {
        webkit.messageHandlers.addMySs.postMessage('selectedSs')
      }
    },
    async selectedSsDone () {
      // ネイティブ経由で渡されるナビゲートの S コード
      const selectedSSCode = window.SELECTED_SS_CODE
      console.log('*** selected-ss :' + selectedSSCode)

      // S コードからの SS 情報取得 API を呼び出し
      await ssByScdApi.get(selectedSSCode).then(res => {
        this.setInspectSsInfo(res.data.body.ss_info)
        // 車検実施SS
        this.car.bestmy_ss_id = res.data.body.ss_info.ss_code
        this.car.bestmy_ss_prefecture = res.data.body.ss_info.prefecture
        this.car.bestmy_ss_factory_type_flag = res.data.body.ss_info.factory_type_flag
        this.setCar(this.car)
        this.checkDifferentIndustriesSsCode(res.data.body.ss_info)
      }).catch(e => {
        console.log('ssApi-error')
        console.log(e.message)
        this.openErrorModal('エラーが発生しました。')
      })
    },
    setInspectSsInfo (ssInfo) {
      this.inspectSsInfo = ssInfo
    },
    // 車検実施店舗のSSが異業種店(SSコードが7始まりの場合)はコミっと車検非対応店舗とする.
    checkDifferentIndustriesSsCode (ssInfo) {
      if (ssInfo.ss_code.startsWith('7')) {
        this.inspectSsInfo.komikomi_flag = 0
      }
    }
  },
  computed: {
    ...mapGetters('CAR', [
      'car'
    ]),
    isInitial () {
      return this.currentState === IS_INITIAL
    },
    isAgreement () {
      return this.currentState === IS_AGREEMENT
    },
    isNotKomikomi () {
      return this.inspectSsInfo.komikomi_flag !== 1
    },
    ssInfoStore: function () {
      return useSsInfoStore()
    },
    profileInfoStore: function () {
      return useProfileInfoStore()
    },
    nativeDataStore: function () {
      return useNativeDataStore()
    },
    versionDataStore: function () {
      return useVersionDataStore()
    },
    inspectSsInfoStore: function () {
      return useInspectSsInfoStore()
    },
    tsIdStore: function () {
      return useTsIdStore()
    }
  },
  async mounted () {
    this.$loadScript('https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js')
    this.$loadScript('/lib/js/main.js')

    // 戻るボタンの出し分け
    this.appDisplayBack(true)

    let isApiError = false

    const ts_id = this.nativeDataStore.nativeData.tsid
    const otoken = this.nativeDataStore.nativeData.otoken
    const popinfo_id = this.nativeDataStore.nativeData.popinfoid

    let priority_other_coupon = {
      usableStartAt: '',
      salevalue: 0
    }
    // 車検クーポン取得
    await otherCouponApi.get(this.profileInfoStore.profileInfo.customer.b_cleID, popinfo_id, ts_id, otoken, this.appVersionMakeRequestHeder(this.versionDataStore.versionData)).then(res => {
      for (let i = 0; i < res.data.body.other_coupon.length; i++) {
        // その他クーポンのカテゴリーが1(車検クーポン)のみ設定する.
        if (res.data.body.other_coupon[i].category === 1) {
          const nowDay = moment().format('YYYY-MM-DD')
          const usableStartAt = moment(res.data.body.other_coupon[i].usableStartAt).format('YYYY-MM-DD')
          const usableEndAt = moment(res.data.body.other_coupon[i].usableEndAt).format('YYYY-MM-DD')

          // 有効期限内、且つ値引額が最大のクーポンを取得.
          if (res.data.body.other_coupon[i].salevalue > priority_other_coupon.salevalue &&
          moment(nowDay).isBetween(usableStartAt, usableEndAt, null, '[]')
          ) {
            priority_other_coupon = res.data.body.other_coupon[i]
            // その他クーポンの割引額は符号無しのため、マイナスを付与する.
            priority_other_coupon.salevalue = priority_other_coupon.salevalue * -1
            this.setCoupon(priority_other_coupon)
          }
        }
      }
    }).catch(e => {
      console.log('otherCouponApi-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    await carTypeApi.get().then(res => {
      this.setCarType(res.data.car_type)
    }).catch(e => {
      console.log('carTypeApi-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    await manufacturerApi.get().then(res => {
      this.setManufacturer(res.data.manufacturer)
    }).catch(e => {
      console.log('manufacturerApi-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    if (this.inspectSsInfoStore.inspectSsInfo == null) {
      // 車検実施SSが渡されていない
      this.inspectSsInfo = this.ssInfoStore.ssInfo
    } else {
      // 車検実施SSが渡されている（見積り実施後の戻り）
      this.inspectSsInfo = this.inspectSsInfoStore.inspectSsInfo
    }
    // SSが異業種店かどうかをチェック.
    this.checkDifferentIndustriesSsCode(this.inspectSsInfo)

    // // 初期表示時に params で渡される ssInfo を inspectSsInfo(車検実施SS)に設定
    // this.inspectSsInfo = this.ssInfoStore.ssInfo
    console.log('*** mounted-inspectSsInfo')
    console.log(this.inspectSsInfo)

    await ssApi.get(this.profileInfoStore.profileInfo.best_myss.code).then(res => {
      this.setSsInfo(res.data.body.ss_info)
    }).catch(e => {
      console.log('ssApi-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    // 見積もりIDを引数にセットする
    await carApi.get(ts_id).then(res => {
      if (res.data.car.length > 0) {
        // 車検満了日
        res.data.car[0].expiryGengo = Number(res.data.car[0].expiry_on.substr(0, 4))
        this.form.expiryMonthSelect = res.data.car[0].expiry_on.substr(5, 2)
        this.form.expiryDaySelect = res.data.car[0].expiry_on.substr(8, 2)

        // 初度登録年月
        res.data.car[0].firstRegistrationGengo = Number(res.data.car[0].first_registration_on.substr(0, 4))
        this.form.firstRegistrationMonthSelect = res.data.car[0].first_registration_on.substr(5, 2)
        res.data.car[0].oil_exchanged = this.car.oil_exchanged
        res.data.car[0].mileage = this.car.mileage
        res.data.car[0].popinfo_id = popinfo_id
        res.data.car[0].coupon = this.coupon
        res.data.car[0].coupon_id = this.coupon.couponCode
        res.data.car[0].coupon_fee = this.coupon.salevalue
        // 車検実施SS
        res.data.car[0].bestmy_ss_id = this.inspectSsInfo.ss_code
        res.data.car[0].bestmy_ss_prefecture = this.inspectSsInfo.prefecture
        res.data.car[0].bestmy_ss_factory_type_flag = this.inspectSsInfo.factory_type_flag
        this.setCar(this.car)
        this.setCar(res.data.car[0])
        // 車検満了日、初度登録年月の元号、年を取得してセットする。
        this.$refs.expiryOnFromH.firstGetGengo(res.data.car[0].expiry_on)
        this.$refs.firstRegistration.firstGetGengo(res.data.car[0].first_registration_on)
      } else {
        this.car.ts_id = ts_id
        this.car.oil_exchanged = this.car.oil_exchanged
        this.car.mileage = this.car.mileage
        this.car.popinfo_id = popinfo_id
        this.car.coupon = this.coupon
        this.car.coupon_id = this.coupon.couponCode
        this.car.coupon_fee = this.coupon.salevalue
        // 車検実施SS
        this.car.bestmy_ss_id = this.inspectSsInfo.ss_code
        this.car.bestmy_ss_prefecture = this.inspectSsInfo.prefecture
        this.car.bestmy_ss_factory_type_flag = this.inspectSsInfo.factory_type_flag
        this.setCar(this.car)
        // 車検証未登録ユーザーの車検満了日デフォルト設定は平成32年
        this.$refs.expiryOnFromH.firstGetGengo('2020-01-01')
        // 車検証未登録ユーザーの初度登録年月デフォルト設定は平成22年
        this.$refs.firstRegistration.firstGetGengo('2010-01-01')
      }
    }).catch(e => {
      console.log('carApi-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
      this.car.ts_id = ts_id
      this.car.oil_exchanged = this.car.oil_exchanged
      this.car.mileage = this.car.mileage
      this.car.popinfo_id = popinfo_id
      this.car.coupon = this.coupon
      this.car.coupon_id = this.coupon.couponCode
      this.car.coupon_fee = this.coupon.salevalue
      // 車検実施SS
      this.car.bestmy_ss_id = this.inspectSsInfo.ss_code
      this.car.bestmy_ss_prefecture = this.inspectSsInfo.prefecture
      this.car.bestmy_ss_factory_type_flag = this.inspectSsInfo.factory_type_flag
      this.setCar(this.car)
      // 車検証未登録ユーザーの車検満了日デフォルト設定は平成32年
      this.$refs.expiryOnFromH.firstGetGengo('2020-01-01')
      // 車検証未登録ユーザーの初度登録年月デフォルト設定は平成22年
      this.$refs.firstRegistration.firstGetGengo('2010-01-01')
    })
    // webviewメンテナンス情報を取得
    await appVerApi.get().then(res => {
      if (res.data.webviewMaintenance.inspection) {
        this.$router.push({
          name: 'CarCareTopV2',
          query: {
            popinfoid: popinfo_id,
            tsid: ts_id,
            otoken,
            x_cls_app_version: this.versionDataStore.versionData.appVersion ? this.versionDataStore.versionData.appVersion : '0.0.0',
            x_cls_os: this.versionDataStore.versionData.platform ? this.versionDataStore.versionData.platform : 'iRidge',
            x_cls_os_version: this.versionDataStore.versionData.osVersion ? this.versionDataStore.versionData.osVersion : '0.0'
          }
        })
      }
    }).catch(e => {
      console.log('appVerApi-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })
    // [eventTrack] 車検見積り 画面表示完了
    this.nativePVset('SHAKEN_MITSUMORI')
    if (!isApiError) {
      this.loading = false
    }
  },
  components: {
    WarekiInput,
    WarekiInputFromH,
    Loading,
    Agreement
  }
}
</script>
